import React, { Component } from 'react';
import queryString from 'query-string';

import './Footer.css';


class Footer extends Component {
  render() {
    const query = queryString.parse(window.location.search)
    const useApp = query.ios === '1' || (navigator.userAgent || '').includes('Cloze Test App')
    const { noApp } = this.props;
    return <div className='AppFooter'>
      <div>
        Copyright(C) 2020-2023 Hiraki Lab.
      </div>
      {!useApp && !noApp && <div>
          <a href='https://apps.apple.com/us/app/clozetest/id1535754798'>
            <img alt='App Store' src='/logo/appstore.svg' />
          </a>
          <a href='https://play.google.com/store/apps/details?id=com.willbooster.cloze_test'>
            <img alt='Google Play' src='/logo/playstore.png' width='135' height='40' />
          </a>
        </div>}
    </div>
  }
}

export default Footer;
